/* eslint-disable import/prefer-default-export */
import { width } from '@mui/system';
import AutocompleteInput from './autocompleteInput';
import Dropdown from './dropdown';
import InputText from './inputText';

export const HOTELS_AND_SIGHTSEEING = 'hotel_and_sightseeings';
export const RESORT = 'resort';
export const TRANSFERS = 'transfers';
export const GENERATED_ITINERARY = 'itinerary';
export const SIGHTSEEING_FIELD = 'sightseeing';
export const AREA_FIELD_KEY = 'area';
export const HOTEL_FIELD_KEY = 'hotel_code';
export const NUMBER_OF_NIGHTS_FIELD_KEY = 'number_of_nights_1';

export const MALDIVES = 'desjkkh';
export const KERALA = 'desjkyd';
export const CURRENCY_INR = 'INR';

export const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export const BOARD_BASIS_FILTER_DATA = [
    {
        id: 'roomOnly',
        label: 'Room Only',
        value: 'roomOnly'
    },
    {
        id: 'breakfast',
        label: 'Breakfast',
        value: 'breakfast'
    },
    {
        id: 'halfBoard',
        label: 'HalfBoard',
        value: 'halfBoard'
    },
    {
        id: 'fullBoard',
        label: 'FullBoard',
        value: 'fullBoard'
    }
];

export const OFFLINE_COMPONENT = 'OFFLINE_COMPONENT';
export const INPUT_TYPE = {
    SINGLE_SELECT_DYNAMIC_DROPDOWN: {
        component: AutocompleteInput,
        multiSelect: false,
        name: 'AutoCompleteInput'
    },
    NUMBER: {
        component: InputText,
        multiSelect: false,
        name: 'InputText'
    },
    MULTI_SELECT_DYNAMIC_DROPDOWN: {
        component: AutocompleteInput,
        multiSelect: true,
        name: 'AutocompleteInput'
    },
    SINGLE_SELECT_STATIC_DROPDOWN: {
        component: Dropdown,
        multiSelect: false,
        name: 'Dropdown'
    },
    OFFLINE_COMPONENT: {
        component: InputText,
        multiSelect: false,
        name: 'InputText'
    }
};

export const ON_REQUEST_BOOKING = 'availablefromsupplier';
export const MAGNUM_PID = 'P5';
export const ABACUS_PID = 'P24';
export const TRUSTU_PID = 'P2';
export const childrenAgeOptions = [
    { value: 1, label: '1' },
    { value: 2, label: '2' },
    { value: 3, label: '3' },
    { value: 4, label: '4' },
    { value: 5, label: '5' },
    { value: 6, label: '6' },
    { value: 7, label: '7' },
    { value: 8, label: '8' },
    { value: 9, label: '9' },
    { value: 10, label: '10' },
    { value: 11, label: '11' },
    { value: 12, label: '12' }
];

export const STAR_RATING_DATA = [
    {
        label: '1 Star',
        value: 1
    },
    {
        label: '2 Star',
        value: 2
    },
    {
        label: '3 Star',
        value: 3
    },
    {
        label: '4 Star',
        value: 4
    },
    {
        label: '5 Star',
        value: 5
    }
];

export const BOARD_BASIS_DATA = {
    boardBasis: {
        filterType: 'boardBasis',
        name: 'Board Basis',
        ids: []
    }
};

export const ROOM_FILTER_DATA = {
    freeCancellation: {
        filterType: 'freeCancellation',
        name: 'Refundable', // 'Free Cancellation',
        status: false
    },
    roomOnly: {
        filterType: 'roomOnly',
        name: 'Room Only',
        ids: ['RoomOnly', 'Other', 'SelfCatering'],
        status: false
    },
    breakfast: {
        filterType: 'breakfast',
        name: 'Breakfast',
        status: false,
        ids: ['BedAndBreakfast']
    },
    halfBoard: {
        filterType: 'halfBoard',
        name: 'HalfBoard',
        ids: ['HalfBoard'],
        status: false
    },
    fullBoard: {
        filterType: 'fullBoard',
        name: 'FullBoard',
        ids: ['FullBoard', 'AllInclusive'],
        status: false
    },
    roomType: {
        filterType: 'roomType',
        name: 'RoomType',
        ids: [],
        status: false
    },
    onRequest: {
        filterType: 'onRequest',
        name: 'On Request Booking',
        ids: [],
        status: false
    },
    panCard: {
        filterType: 'panCard',
        name: 'No Pan Card',
        ids: [],
        status: false
    },
    holdAvailable: {
        filterType: 'hold',
        name: 'Hold Available',
        ids: [],
        status: false
    },
    contractedRate: {
        filterType: 'contractedRate',
        name: 'Contracted Rate',
        ids: [],
        status: false
    }
};

export const QUOTE_TYPE_DATA = [
    {
        label: 'Full Quote',
        value: 'quote'
    },
    {
        label: 'Land Only Quote',
        value: 'landQuote'
    }
    // {
    //     label: 'Hotels Only',
    //     value: 'hotel'
    // },
    // {
    //     label: 'Transfers Only',
    //     value: 'transfer'
    // },
    // {
    //     label: 'Sightseeing Only',
    //     value: 'sightseeing'
    // }
];

export const INPUT_WIDTH = {
    area: {
        xs: '4'
    },
    hotel_code: {
        xs: '4'
    },
    room_code_1: {
        xs: '3.5'
    },
    room_code_2: {
        xs: '3.5'
    },
    number_of_nights_1: {
        xs: '3.5'
    },
    number_of_nights_2: {
        xs: '3.5'
    },
    meal_plan: {
        xs: '3.5'
    },
    sightseeing: {
        xs: '4'
    },
    pickup_from: {
        xs: '5.5'
    },
    drop_at: {
        xs: '5.5'
    },
    transfer_type: {
        xs: '3.5'
    },
    cab_type: {
        xs: '3.5'
    },
    no_of_cabs: {
        xs: '3.5'
    },
    type_of_stay: {
        xs: '3.5'
    }
};
export const HHI_FORM_WIDTHS_TRANSFER_FORM = {
    pickup_from: {
        width: 2.5
    },
    drop_at: {
        width: 2.5
    },
    transfer_type: {
        width: 2
    },
    cab_type: {
        width: 2
    },
    number_of_cabs: {
        width: 1.5
    }
};

export const MEAL_TYPE = {
    0: 'CP',
    1: 'MAP',
    2: 'AP',
    3: 'RO',
    4: 'AI'
};

export const MEAL_PLAN = [
    {
        label: 'CP',
        value: 'CP',
        name: 'CP'
    },
    {
        label: 'MAP',
        value: 'MAP',
        name: 'MAP'
    },
    {
        label: 'AP',
        value: 'AP',
        name: 'AP'
    },
    {
        label: 'RO',
        value: 'RO',
        name: 'RO'
    },
    {
        label: 'AI',
        value: 'AI',
        name: 'AI'
    }
];

export const TRANSFER_TYPES = [
    {
        label: 'PRIVATE',
        value: 0,
        key: 'PRIVATE'
    },
    {
        label: 'SIC',
        value: 1,
        key: 'SIC'
    }
];

export const SIGHTSEEING_TRANSFER_TYPES = [
    {
        label: 'PRIVATE',
        value: 0,
        key: 'PRIVATE'
    },
    {
        label: 'SIC',
        value: 1,
        key: 'SIC'
    },
    {
        label: 'TICKETS_ONLY',
        value: 2,
        key: 'TICKETS_ONLY'
    }
];

export const TOOLTIP_VIEW = 'toolTipView';
export const DEFAULT_BOARDBASIS_DESC = 'Room Only';
export const FREEMEAL_BOARDBASIS_TYPES = ['BedAndBreakfast', 'HalfBoard', 'FullBoard', 'AllInclusive'];
export const SUPPLIER_CONSTATNTS = ['p5', 'p24', 'P5', 'P24'];
export const TYPE_OF_STAYS = [
    {
        label: 'Single Stay',
        value: 'Single Stay'
    },
    {
        label: 'Split Stay',
        value: 'Split Stay'
    }
];

export const ROOM_DATA = {
    adult_count: 2,
    child_count: 0,
    child_ages: [],
    infant_count: 0
};

export const copyOfObject = (obj) => JSON.parse(JSON.stringify(obj || {}));
export const MODULE_ACCESS_CREATE_QUOTES = 'CREATE_QUOTES';

export const HOTEL_STAR_RATINGS = [
    { label: '5 star', value: 5, id: 5 },
    { label: '4 star', value: 4, id: 4 },
    { label: '3 star', value: 3, id: 3 },
    { label: '2 star', value: 2, id: 2 },
    { label: 'Unrated', value: 1, id: 1 }
];
export const SORTING_LIST = [
    { label: 'Relevance', value: 1, id: 1, finalRate: 'default' },
    { label: 'Price: Low to High', value: 2, id: 2, finalRate: 'asc' },
    { label: 'Price: High to Low', value: 3, id: 3, finalRate: 'dsc' }
];

export const HOTEL_PRICE = [
    { label: 'Less than INR 2,000', value: 1, id: 1, min: null, max: 2000 },
    { label: 'INR 2,000 - INR 3,000 ', value: 2, id: 2, min: 2000, max: 3000 },
    { label: 'INR 3,001 - INR 5,000 ', value: 3, id: 3, min: 3001, max: 5000 },
    { label: 'INR 5,001 - INR 7,000', value: 4, id: 4, min: 5001, max: 7000 },
    { label: 'More than INR 7,000', value: 5, id: 5, min: 7000, max: null }
];

export const TAGS = [
    {
        tagCode: 'tagjky0',
        name: 'Luxury Stay'
    },
    {
        tagCode: 'tagjkk7',
        name: 'Most Popular'
    },
    {
        tagCode: 'tagjkkv',
        name: 'Budget'
    },
    {
        tagCode: 'tagjk4h',
        name: 'Exclusive Price'
    },
    {
        tagCode: 'tagjkrm',
        name: 'Bur Dubai'
    },
    {
        tagCode: 'tagjkyq',
        name: 'Couple Friendly'
    },
    {
        tagCode: 'tagjkyb',
        name: 'Weekend Getaway'
    },
    {
        tagCode: 'tagjk45',
        name: 'Family and Kids'
    },
    {
        tagCode: 'tagjk4k',
        name: 'Business Travel'
    },
    {
        tagCode: 'tagjkyo',
        name: 'Top Rated'
    },
    {
        tagCode: 'tagjkr7',
        name: 'Deira'
    },
    {
        tagCode: 'tagjkkp',
        name: 'Business Meet'
    },
    {
        tagCode: 'tagjkkh',
        name: 'Swimming Pool'
    },
    {
        tagCode: 'tagjkrs',
        name: 'Sheikh Zayed Road'
    },
    {
        tagCode: 'tagjkyy',
        name: 'Family Friendly'
    },
    {
        tagCode: 'tagjkrp',
        name: 'Great Price'
    },
    {
        tagCode: 'tagjk4d',
        name: 'Beach View'
    },
    {
        tagCode: 'tagjkr6',
        name: 'Downtown'
    },
    {
        tagCode: 'tagjkk6',
        name: 'Kid Friendly'
    },
    {
        tagCode: 'tagjkyi',
        name: 'Near Airport'
    },
    {
        tagCode: 'tagjk4c',
        name: 'Top Location'
    },
    {
        tagCode: 'tagjky8',
        name: 'Value for Money'
    },
    {
        tagCode: 'tagjk42',
        name: 'Multiple Dining Options'
    }
];

export const RATING_OPTION = [
    {
        label: '4.5 & above (171)',
        count: 171,
        rating: 4.5
    },
    {
        label: '4 & above (429)',
        count: 429,
        rating: 4
    },
    {
        label: '3 & above (597)',
        count: 597,
        rating: 3
    }
];

export const PROPERTY_TYPE = [
    'Hotel',
    'Aparthotel',
    'Resort',
    'Apartment',
    'Private Vacation Home',
    'Villa',
    'Hostel',
    'Residence',
    'GuestHouse'
];

export const AVAILABLE_FACILITIES = [
    'Parking',
    'Lounge',
    'Childcare Service',
    'Breakfast',
    'Business Center',
    'Bar',
    'Spa',
    'Non Smoking',
    'Television',
    'Laundry Services',
    'Swimming Pool',
    'Restaurant',
    'Internet',
    'Fitness Facility',
    'Airport Shuttle',
    'Golf',
    'Pets Allowed',
    'Casino',
    'Refrigerator'
];

export const ADD_HOTEL = 'ADD_HOTEL';
export const CHANGE_HOTEL = 'CHANGE_HOTEL';
export const CHANGE_ROOM = 'CHANGE_ROOM';
